module.exports = __webpack_public_path__ + "static/media/Hydraulics_SWF-Medium.8e90daad.gif";